const topicItems = [
  { id: 1, name: '悬疑推理', count: '2.3万讨论', hot: true },
  { id: 2, name: '国产新片', count: '1.8万讨论', hot: true },
  { id: 3, name: '好莱坞大片', count: '3.1万讨论', hot: true },
  { id: 4, name: '动画电影', count: '9,800讨论', hot: false },
  { id: 5, name: '恐怖惊悚', count: '1.5万讨论', hot: true },
  { id: 6, name: '爱情文艺', count: '8,200讨论', hot: false },
  { id: 7, name: '科幻巨制', count: '2.7万讨论', hot: true },
  { id: 8, name: '纪录片', count: '6,500讨论', hot: false },
  { id: 9, name: '日韩影视', count: '1.2万讨论', hot: false },
  { id: 10, name: '经典老片', count: '1.9万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">影迷们在讨论什么？看看当下最热门的电影话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative flex items-center gap-3 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              {item.hot && (
                <span className="absolute -top-2 -right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-bold whitespace-nowrap">热</span>
              )}
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">{item.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}